(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1163,7765],{

/***/ 59295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[id]/[slug]",
      function () {
        return __webpack_require__(80488);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/utils/collection.utils.ts
var collection_utils = __webpack_require__(85295);
// EXTERNAL MODULE: ./src/utils/normalizers/collection.ts
var normalizers_collection = __webpack_require__(36493);
// EXTERNAL MODULE: ./src/providers/collection/CollectionProvider.tsx + 1 modules
var CollectionProvider = __webpack_require__(67183);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/cards/GroupCardSvg.tsx
var GroupCardSvg = __webpack_require__(28907);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthScrollableWrapper.tsx
var FullWidthScrollableWrapper = __webpack_require__(22319);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/components/layout/components/SectionTitle.tsx
var SectionTitle = __webpack_require__(57401);
;// CONCATENATED MODULE: ./src/components/collection/CollectionCarousel.tsx










// TODO - refactor this component to accept a header renderer defaulting to SectionTitle
// and an item renderer defaulting to GroupCardSvg
// and a generic type for the item renderer and another for the header renderer
var DEFAULT_ITEM_RENDERER = function(param) {
    var item = param.item, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupCardSvg/* default */.Z, {
        data: item,
        dataType: "collection",
        width: {
            base: esm.spacing.toRem(216),
            md: (0,global/* getRemWidthFromColumns */._P)(3)
        },
        withLink: true
    }, index);
};
var CollectionCarousel = function(_param) {
    var items = _param.items, _itemRenderer = _param.itemRenderer, itemRenderer = _itemRenderer === void 0 ? DEFAULT_ITEM_RENDERER : _itemRenderer, sectionTitle = _param.sectionTitle, props = (0,_object_without_properties/* default */.Z)(_param, [
        "items",
        "itemRenderer",
        "sectionTitle"
    ]);
    var _mt, ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                marginTop: (ref = (_mt = props.mt) !== null && _mt !== void 0 ? _mt : props.marginTop) !== null && ref !== void 0 ? ref : esm.spacing.toRem(global/* GAP_SIZE */.DG * 1.5),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, (0,_object_spread/* default */.Z)({}, sectionTitle))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthScrollableWrapper/* default */.Z, {
                children: items.map(function(item, index) {
                    return itemRenderer ? itemRenderer({
                        item: item,
                        index: index
                    }) : DEFAULT_ITEM_RENDERER({
                        item: item,
                        index: index
                    });
                })
            })
        ]
    });
};
/* harmony default export */ var collection_CollectionCarousel = (CollectionCarousel);

// EXTERNAL MODULE: ./src/components/layout/Layout.tsx + 6 modules
var Layout = __webpack_require__(28146);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
// EXTERNAL MODULE: ./src/utils/landingPageData.tsx
var landingPageData = __webpack_require__(74277);
// EXTERNAL MODULE: ./src/utils/metadata.utils.ts
var metadata_utils = __webpack_require__(83337);
// EXTERNAL MODULE: ./src/utils/strings/pageStrings.ts
var pageStrings = __webpack_require__(23244);
// EXTERNAL MODULE: ./src/page-components/collection/old/CollectionContainer.tsx + 1 modules
var CollectionContainer = __webpack_require__(63197);
// EXTERNAL MODULE: ./src/page-components/collection/old/CollectionHeader.tsx
var CollectionHeader = __webpack_require__(71173);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useCollection.ts
var useCollection = __webpack_require__(58397);
// EXTERNAL MODULE: ./src/providers/hooks/useNsi.ts
var useNsi = __webpack_require__(9182);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/strings/actionStrings.ts
var actionStrings = __webpack_require__(89134);
// EXTERNAL MODULE: ./src/components/hashtag/HashtagChipCarousel.tsx
var HashtagChipCarousel = __webpack_require__(41914);
// EXTERNAL MODULE: ./src/page-components/collection/old/ProgressBar.tsx
var ProgressBar = __webpack_require__(93240);
;// CONCATENATED MODULE: ./src/page-components/collection/old/CollectionHeaderV2.tsx


















var COMPLETED_CTA_EXTRA_PROPS = {
    _hover: {
        shadow: "none",
        cursor: "unset"
    },
    _active: {
        backgroundColor: esm.color.success
    }
};
var CollectionHeaderV2 = function() {
    var collection = (0,useCollection/* default */.Z)().collection;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var profile = (0,useProfile/* default */.Z)().profile;
    var nsiDispatch = (0,useNsi/* default */.Z)().nsiDispatch;
    var collectionStatus = collection && (0,collection_utils/* getCollectionStatus */.t2)({
        collection: collection
    });
    var getCta = (0,react.useMemo)(function() {
        if (!collection) return null;
        switch(collectionStatus){
            case enums/* CollectionStatus.STARTED */.Nb.STARTED:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                size: "m",
                                type: "bold",
                                whiteSpace: "nowrap",
                                children: actionStrings/* default.continueReading */.Z.continueReading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.ArrowLeftSvg, {
                                color: esm.color[colorMode].textInverted,
                                boxSize: {
                                    base: esm.spacing.L.rem,
                                    lg: esm.spacing.XL.rem
                                },
                                ml: esm.spacing.XS.rem,
                                transform: "rotate(-180deg)"
                            })
                        ]
                    });
                }
            case enums/* CollectionStatus.NEW */.Nb.NEW:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                color: esm.color[colorMode].textInverted,
                                size: "m",
                                type: "bold",
                                whiteSpace: "nowrap",
                                children: actionStrings/* default.startReading */.Z.startReading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.ArrowLeftSvg, {
                                color: esm.color[colorMode].textInverted,
                                boxSize: {
                                    base: esm.spacing.L.rem,
                                    lg: esm.spacing.XL.rem
                                },
                                ml: esm.spacing.XS.rem,
                                transform: "rotate(-180deg)"
                            })
                        ]
                    });
                }
            case enums/* CollectionStatus.COMPLETED */.Nb.COMPLETED:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CheckFillSvg, {
                                color: esm.color.light.textInverted,
                                mr: esm.spacing.XS.rem
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                color: esm.color.light.textInverted,
                                size: "m",
                                type: "bold",
                                whiteSpace: "nowrap",
                                children: actionStrings/* default.allRead */.Z.allRead
                            })
                        ]
                    });
                }
            default:
                {
                    return null;
                }
        }
    }, [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas,
        collection === null || collection === void 0 ? void 0 : collection.progress.completed,
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType,
        colorMode, 
    ]);
    var getCtaBackgroundColor = (0,react.useMemo)(function() {
        if (!collection) return "";
        if (collection === null || collection === void 0 ? void 0 : collection.progress.completed) {
            return esm.color.success;
        } else {
            return esm.color[colorMode].text;
        }
    }, [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas,
        collection === null || collection === void 0 ? void 0 : collection.progress.completed,
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType,
        colorMode, 
    ]);
    var onClickCtaHandler = (0,react.useCallback)(function() {
        if (!collection) return;
        if (!isLoggedIn) {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-up"
                }
            });
        } else if (collection === null || collection === void 0 ? void 0 : collection.progress.completed) {
            return;
        } else {
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: (collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas) === 0 ? analytics/* Events.consumption.collectionStartReading */.z.consumption.collectionStartReading : analytics/* Events.consumption.collectionContinueReading */.z.consumption.collectionContinueReading,
                properties: {
                    collectionId: collection === null || collection === void 0 ? void 0 : collection.id,
                    location: "collection-page"
                },
                platforms: [
                    "amplitude"
                ]
            });
            router_default().push((0,collection_utils/* getNextSourceToReadFromCollectionUrl */.e7)({
                collection: collection
            }));
        }
    }, [
        collection,
        collection === null || collection === void 0 ? void 0 : collection.progress.totalReadIdeas,
        collection === null || collection === void 0 ? void 0 : collection.progress.completed,
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType, 
    ]);
    // const seeAllLink = (
    //   <NextLink href="/all-collections">
    //     <PrimaryText color={color[colorMode].primary} fontWeight="bold">
    //       {actionStrings.seeAllCollections}
    //     </PrimaryText>
    //   </NextLink>
    // );
    if (!collection) return null;
    var cta = !isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: "lg",
        _hover: {
            backgroundColor: esm.color[colorMode === "dark" ? "light" : "dark"].underground
        },
        width: {
            base: "100%",
            md: (0,global/* getRemWidthFromColumns */._P)(3)
        },
        height: esm.spacing.toRem(54),
        onClick: onClickCtaHandler,
        transition: "background-color 0.3s ease-out",
        backgroundColor: esm.color[colorMode].text,
        color: esm.color[colorMode].textInverted
    }, esm.typography.primaryTextFonts.large.semiBold), {
        align: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
            children: actionStrings/* default.signUpToReadForFree */.Z.signUpToReadForFree
        })
    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        size: "lg",
        width: {
            base: "calc(100%)",
            md: esm.spacing.toRem(212)
        },
        px: {
            base: esm.spacing.M.rem,
            lg: esm.spacing.toRem(48)
        },
        height: esm.spacing.toRem(54),
        backgroundColor: getCtaBackgroundColor,
        onClick: onClickCtaHandler
    }, collectionStatus === enums/* CollectionStatus.COMPLETED */.Nb.COMPLETED ? COMPLETED_CTA_EXTRA_PROPS : {}), {
        overflow: "hidden",
        border: 0,
        _hover: undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                align: "center",
                children: getCta
            }),
            collection.progress.totalReadIdeas > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar/* default */.Z, {
                currentValue: collection.progress.totalReadIdeas,
                totalValue: collection.ideaCount,
                flexGrow: 1,
                left: 0,
                width: "100%",
                bottom: 0,
                height: esm.spacing.toRem(4),
                borderRadius: esm.spacing.toRem(4),
                position: "absolute",
                bgColor: esm.color[colorMode].textSecondary,
                isPadded: true
            })
        ]
    }));
    var _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        w: "100%",
        flexDir: "column",
        zIndex: 2,
        justifyContent: "flex-end",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            mb: esm.spacing.toRem(48),
            w: "100%",
            justifyContent: "space-between",
            alignItems: "flex-end",
            gridGap: global/* GAP_SIZE_REM */.L3,
            flexDirection: {
                base: "column",
                md: "row"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    gridGap: global/* GAP_SIZE_REM */.L3,
                    alignItems: "flex-start",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                fontSize: {
                                    base: "2rem",
                                    md: "3rem"
                                },
                                children: collection.emoji
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                            flexDirection: "column",
                            height: "auto",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                                    size: "h1",
                                    textSize: "xl",
                                    color: esm.color[colorMode].text,
                                    lineHeight: {
                                        base: "2.5rem",
                                        md: "3.5rem"
                                    },
                                    fontWeight: 800,
                                    fontSize: {
                                        base: "2rem",
                                        md: "3rem"
                                    },
                                    noOfLines: 2,
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                    color: esm.color[colorMode].text,
                                    opacity: 0.8,
                                    size: isMobileView ? "s" : "m",
                                    mt: esm.spacing.M.rem,
                                    display: "flex",
                                    children: (_description = collection.description) !== null && _description !== void 0 ? _description : ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HashtagChipCarousel/* default */.Z, {
                                    hashtags: collection.hashtags.map(function(hashtag) {
                                        return {
                                            name: hashtag
                                        };
                                    }),
                                    color: esm.color[colorMode].text,
                                    numberOfChipsThreshold: isMobileView ? 1 : 10,
                                    opacity: 0.4,
                                    mt: esm.spacing.XXS.rem,
                                    renderItem: function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            href: "/topic/".concat(item.item.name),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                                _focus: undefined,
                                                _hover: undefined,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryText, {
                                                    mr: esm.spacing.XXS.rem,
                                                    children: [
                                                        "#",
                                                        item.item.name
                                                    ]
                                                })
                                            })
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                }),
                cta
            ]
        })
    });
};
/* harmony default export */ var old_CollectionHeaderV2 = (CollectionHeaderV2);

// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
;// CONCATENATED MODULE: ./src/page-components/collection/old/CollectionSplashscreenBackground.tsx








var CollectionSplashscreenBackground = function(_param) {
    var collectionId = _param.collectionId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "collectionId"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    if (!collectionId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "absolute",
        width: "100vw",
        aspectRatio: {
            base: "9/16",
            md: "16/9"
        },
        maxHeight: "110vh",
        top: 0,
        left: 0,
        overflow: "hidden",
        zIndex: -1
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                wrapperStyle: {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                },
                imageUrl: "https://static.deepstash.com/collection/".concat(isMobileView ? "" : "landscape/").concat(collectionId, ".svg"),
                priority: true
            }),
            colorMode === "dark" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                position: "absolute",
                height: esm.spacing.toRem(256),
                width: "100%",
                top: 0,
                left: 0,
                background: (0,constants/* createGradient */.FK)(esm.color[colorMode].background, 90)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                position: "absolute",
                height: "50%",
                width: "100%",
                bottom: 0,
                left: 0,
                background: (0,constants/* createGradient */.FK)(esm.color[colorMode].background, 270)
            })
        ]
    }));
};
/* harmony default export */ var old_CollectionSplashscreenBackground = (CollectionSplashscreenBackground);

// EXTERNAL MODULE: ./src/utils/metatopics.constants.ts
var metatopics_constants = __webpack_require__(90031);
;// CONCATENATED MODULE: ./src/page-components/collection/old/CollectionPage.tsx
















// DEPRECATED
var CollectionPage = function(param) {
    var collection = param.collection, isInitialLoggedIn = param.isInitialLoggedIn;
    var ref, ref1;
    var collectionTitleSection = {
        content: constants/* FANCY_GRAPHICS_COLLECTION_IDS.includes */.LG.includes(collection.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
            height: "calc(100vh - 96px)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(old_CollectionHeaderV2, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeader/* default */.Z, {
            roundedHeaderImage: true
        }),
        isFullscreen: constants/* FANCY_GRAPHICS_COLLECTION_IDS.includes */.LG.includes(collection.id)
    };
    var collectionSourcesSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionContainer/* default */.Z, {})
    };
    var moreCollectionsSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(collection_CollectionCarousel, {
            items: landingPageData/* LANDING_PAGE_COLLECTIONS.filter */.Qq.filter(function(coll) {
                return coll.id !== collection.id;
            }),
            sectionTitle: {
                preTitle: pageStrings/* default.landing.sourcesHeader.preTitle */.Z.landing.sourcesHeader.preTitle,
                title: pageStrings/* default.landing.sourcesHeader.title */.Z.landing.sourcesHeader.title
            },
            mb: {
                base: global/* GAP_SIZE_REM */.L3,
                md: global/* SECTION_GAP_REM */.hM
            }
        }),
        isFullscreen: true
    };
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionProvider/* default */.Z, {
        collection: collection,
        isInitialRequestLoggedIn: isInitialLoggedIn,
        children: [
            constants/* FANCY_GRAPHICS_COLLECTION_IDS.includes */.LG.includes(collection.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(old_CollectionSplashscreenBackground, {
                collectionId: collection.id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                pageMetadata: (0,metadata_utils/* getCollectionPageMetadata */.NJ)({
                    collection: collection
                }),
                sections: [
                    collectionTitleSection,
                    collectionSourcesSection,
                    moreCollectionsSection, 
                ],
                breadcrumbs: !!((ref = collection.hashtags) === null || ref === void 0 ? void 0 : ref.length) ? [
                    {
                        title: "Home",
                        link: "/"
                    },
                    {
                        title: (ref2 = (ref1 = metatopics_constants/* UNSORTED_TOPICS */.Ay[collection.hashtags[0]]) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref2 !== void 0 ? ref2 : collection.hashtags[0],
                        link: "/topic/" + collection.hashtags[0]
                    },
                    {
                        title: collection.name,
                        link: "/collection/".concat(collection.id, "/").concat((0,global/* slugify */.lV)(collection.name))
                    }, 
                ] : undefined
            })
        ]
    });
};
/* harmony default export */ var old_CollectionPage = (CollectionPage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/breadcrumbs/BreadcrumbList.tsx
var BreadcrumbList = __webpack_require__(920);
// EXTERNAL MODULE: ./src/components/layout/components/Footer.tsx + 3 modules
var Footer = __webpack_require__(56096);
// EXTERNAL MODULE: ./src/components/navbar/Navbar.tsx + 2 modules
var Navbar = __webpack_require__(43117);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingProSection.tsx + 1 modules
var LandingProSection = __webpack_require__(8190);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./src/components/faq/FaqGroup.tsx
var FaqGroup = __webpack_require__(27984);
;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionFAQSection.tsx







var TITLE = "Frequently asked questions";
var FAQ_ITEMS_GENERAL = [
    {
        title: "What is Deepstash?",
        description: "Deepstash is a platform where users read and curate bite-sized insights and ideas from anywhere online, may that be books, articles, podcasts, or videos. You can learn good habits, useful skills and build your knowledge, on your own time. Deepstash makes your personal growth manageable!"
    },
    {
        title: "Why are ideas important?",
        description: "Ideas are important because they form the foundation for progress and innovation. The idea format used by Deepstash is important because it condenses complex concepts and profound thoughts into simple, digestible sentences that are easy to understand and remember. This format makes ideas more accessible and easier to apply in daily life, helping people to make positive changes and achieve their goals."
    },
    {
        title: "How can I use Deepstash?",
        description: "Deepstash can be found on both the Apple App Store and Google Play Store. Additionally, Deepstash can be found on the web, where you can login and use Deepstash at deepstash.com."
    }, 
];
var FAQ_ITEMS_PRO = [
    // TODO No Trial Changes
    // {
    //   title: 'How does the free 7-day trial work?',
    //   description:
    //     "Start your free 7-day trial by signing up for a Deepstash Pro yearly plan. There’s no obligation to stay subscribed, and you'll only be charged on the day the free 7-day trial ends. You have access to all the Pro features during the trial.",
    // },
    {
        title: "What is included in my Deepstash subscription?",
        description: "With Pro, you get all of Deepstash amazing content, but your interaction with it is unrestrained. Save as many ideas as you want, in as many stashes you desire. You can also go offline and still have access to your content, while also listening to your ideas whenever, wherever."
    },
    {
        title: "Can I cancel at any time?",
        // description:
        //   'Yes. If you are on a trial and you cancel it, you won’t be charged. If you have an ongoing subscription, you will keep your benefits until the next billing date.',
        description: "Yes. If you have an ongoing subscription, you will keep your benefits until the next billing date."
    },
    {
        title: "When is my Lifetime Pro subscription activated?",
        description: "Due to the nature of payment processing, please allow up to 24h for your Lifetime Pro subscription to become active."
    }, 
];
var CollectionFAQSection = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.bold : esm.typography.primaryHeadingFonts.large.bold), {
                color: esm.color[colorMode].text,
                textAlign: "center",
                children: TITLE
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                width: isMobileView ? "100%" : "80%",
                mt: 32,
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqGroup/* default */.Z, {
                        faqItems: FAQ_ITEMS_GENERAL,
                        groupTitle: "General"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqGroup/* default */.Z, {
                        faqItems: FAQ_ITEMS_PRO,
                        groupTitle: "Pro Subscription",
                        mt: 48
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CollectionFAQSection = (CollectionFAQSection);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/idea-card/IdeaCard.tsx + 4 modules
var IdeaCard = __webpack_require__(63848);
// EXTERNAL MODULE: ./src/utils/normalizers/source.ts + 1 modules
var source = __webpack_require__(27079);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingStartTrialButton.tsx
var LandingStartTrialButton = __webpack_require__(83934);
;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionKeyIdeasSection.tsx









var IDEAS_COUNT = 3;
var IDEA_SIZE = {
    WIDTH: 340,
    HEIGHT: 480
};
var IDEA_SIZE_MOBILE = {
    WIDTH: 280,
    HEIGHT: 400
};
var IDEA_OVERLAY_HEIGHT = 200;
var IDEA_OVERLAY_HEIGHT_MOBILE = 160;
var IDEA_LAST_OVERLAY_HEIGHT = 470;
var IDEA_LAST_OVERLAY_HEIGHT_MOBILE = 390;
var CollectionKeyIdeasSection = function(param) {
    var articles = param.articles, totalIdeas = param.totalIdeas;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var ideasShowed = react.useMemo(function() {
        var allFeaturedIdeas = [];
        var allIdeas = [];
        articles.forEach(function(article) {
            var ref;
            var featuredIdeasInArticle = (ref = article.blocks) === null || ref === void 0 ? void 0 : ref.filter(function(block) {
                return block.is_featured_in_collection === true;
            });
            if (featuredIdeasInArticle !== undefined && featuredIdeasInArticle.length > 0) {
                var _allFeaturedIdeas;
                (_allFeaturedIdeas = allFeaturedIdeas).push.apply(_allFeaturedIdeas, (0,_to_consumable_array/* default */.Z)(featuredIdeasInArticle));
            }
            if (article.blocks !== undefined && article.blocks !== null) {
                var _allIdeas;
                (_allIdeas = allIdeas).push.apply(_allIdeas, (0,_to_consumable_array/* default */.Z)(article.blocks));
            }
        });
        if (allFeaturedIdeas.length >= IDEAS_COUNT) {
            return allFeaturedIdeas.slice(0, IDEAS_COUNT);
        }
        // Return first 3 ideas from first source (sources)
        // and with content >= 400
        var filteredAllIdeas = allIdeas.filter(function(idea) {
            return idea.content.length >= 400;
        });
        return filteredAllIdeas.slice(0, IDEAS_COUNT);
    }, [
        articles
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.bold : esm.typography.primaryHeadingFonts.large.bold), {
                color: esm.color[colorMode].text,
                textAlign: "center",
                children: "3 Top Key Ideas (".concat(totalIdeas, " total)")
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                flexDirection: "row",
                gridColumnGap: 16,
                mt: 16,
                w: "100%",
                overflow: {
                    base: "scroll",
                    md: "hidden"
                },
                justifyContent: isMobileView ? "flex-start" : "center"
            }, isMobileView ? {
                px: 16,
                pb: 16
            } : {}), {
                children: ideasShowed.map(function(idea, index) {
                    var normalizedIdea = (0,source/* normalizeIdea */.NA)(idea);
                    var isLastIdea = index === IDEAS_COUNT - 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "column",
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCard/* default */.Z, {
                                ideaData: {
                                    idea: normalizedIdea,
                                    source: null
                                },
                                isNotInteractable: true,
                                height: isMobileView ? IDEA_SIZE_MOBILE.HEIGHT : IDEA_SIZE.HEIGHT,
                                width: isMobileView ? IDEA_SIZE_MOBILE.WIDTH : IDEA_SIZE.WIDTH,
                                hideImage: true,
                                position: "relative",
                                disableTitleHref: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                position: "absolute",
                                left: 0,
                                right: 0,
                                bottom: 0,
                                height: isLastIdea ? isMobileView ? IDEA_LAST_OVERLAY_HEIGHT_MOBILE : IDEA_LAST_OVERLAY_HEIGHT : isMobileView ? IDEA_OVERLAY_HEIGHT_MOBILE : IDEA_OVERLAY_HEIGHT,
                                background: isLastIdea ? "linear-gradient(0deg, rgba(255,255,255,1) 56%, rgba(255,255,255,0.3))" : "linear-gradient(0deg, rgba(255,255,255,1) 10%, rgba(255,255,255,0.2))",
                                borderRadius: "1.25rem",
                                children: isLastIdea ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    pb: 32,
                                    px: 32,
                                    width: isMobileView ? IDEA_SIZE_MOBILE.WIDTH : IDEA_SIZE.WIDTH,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.semiBold), {
                                            color: esm.color[colorMode].text,
                                            textAlign: "center",
                                            children: "Want to learn more? Unlock this collection and all ".concat(totalIdeas, " key ideas.")
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartTrialButton/* default */.Z, {
                                            landingLocation: "collection-key-ideas",
                                            mt: 24
                                        })
                                    ]
                                }) : null
                            })
                        ]
                    }, index);
                })
            }))
        ]
    });
};
/* harmony default export */ var components_CollectionKeyIdeasSection = (CollectionKeyIdeasSection);

;// CONCATENATED MODULE: ./src/page-components/collection/components/BookImageCollection.tsx







var BOOK_IMAGE_STYLE = {
    w: "50%",
    h: "75%",
    zIndex: 2,
    borderTopRightRadius: "5%",
    borderBottomRightRadius: "5%"
};
var BookImageCollection = function(_param) {
    var size = _param.size, nextImageProps = _param.nextImageProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "nextImageProps"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        justifyContent: "center",
        alignItems: "center",
        pos: "relative",
        flexShrink: 0,
        zIndex: 1,
        overflow: "hidden",
        w: size,
        h: size
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 335 335",
                    fill: "none",
                    position: "absolute"
                }, props), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                        clipPath: "url(#clip0_1658_106549)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M76 46C76 43.7909 77.7909 42 80 42H84V293.25H80C77.7909 293.25 76 291.459 76 289.25V46Z",
                                fill: esm.color[colorMode].text,
                                fillOpacity: "0.8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M257 54C257 51.7909 255.209 50 253 50V285C255.209 285 257 283.209 257 281V54Z",
                                fill: "#FAF7F3"
                            })
                        ]
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, (0,_object_spread/* default */.Z)({
                    wrapperStyle: BOOK_IMAGE_STYLE,
                    isNotInteractable: true,
                    objectFit: "cover",
                    priority: true
                }, nextImageProps))
            ]
        })
    }));
};
/* harmony default export */ var components_BookImageCollection = (BookImageCollection);

;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionOverviewSection.tsx







var SOURCE_SIZE = {
    WIDTH_CONTAINER: 200,
    WIDTH: 180,
    HEIGHT: 250
};
var SOURCE_SIZE_MOBILE = {
    WIDTH_CONTAINER: 160,
    WIDTH: 140,
    HEIGHT: 200
};
var AUTHOR_SIZE = {
    WIDTH_CONTAINER: 200,
    WIDTH: 200,
    HEIGHT: 200
};
var AUTHOR_SIZE_MOBILE = {
    WIDTH_CONTAINER: 160,
    WIDTH: 160,
    HEIGHT: 160
};
var DEFAULT_AUTHOR_IMAGE = "https://static.deepstash.com/images/author-placeholder.png";
var CollectionOverviewSection = function(param) {
    var collection = param.collection;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var renderSourcesView = function() {
        var ref;
        if (((ref = collection.seo) === null || ref === void 0 ? void 0 : ref.featured_sources) !== undefined && collection.seo.featured_sources.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDirection: "column",
                width: "100%",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.bold : esm.typography.primaryHeadingFonts.large.bold), {
                        color: esm.color[colorMode].text,
                        textAlign: "center"
                    }), isMobileView ? {
                        px: 16
                    } : {}), {
                        children: "Ideas from books, podcasts, videos & articles"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        width: "100%",
                        flexDirection: "row",
                        gridColumnGap: 16,
                        justifyContent: isMobileView ? "start" : "center",
                        mt: -16
                    }, isMobileView ? {
                        overflow: "scroll",
                        px: 16,
                        pb: 8
                    } : {}), {
                        children: collection.seo.featured_sources.slice(0, 5).map(function(source, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                w: isMobileView ? SOURCE_SIZE_MOBILE.WIDTH_CONTAINER : SOURCE_SIZE.WIDTH_CONTAINER,
                                flexDirection: "column",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BookImageCollection, {
                                        size: 300,
                                        nextImageProps: {
                                            imageUrl: source.image,
                                            alt: "".concat(source.title),
                                            priority: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "center"
                                    }, isMobileView ? esm.typography.primaryTextFonts.large.regular : esm.typography.primaryHeadingFonts.small.regular), {
                                        color: esm.color[colorMode].text,
                                        noOfLines: 3,
                                        w: isMobileView ? SOURCE_SIZE_MOBILE.WIDTH_CONTAINER : SOURCE_SIZE.WIDTH_CONTAINER,
                                        mt: -16,
                                        children: "".concat(source.title)
                                    }))
                                ]
                            }, index);
                        })
                    }))
                ]
            });
        } else {
            return null;
        }
    };
    var renderPeopleView = function() {
        var ref;
        if (((ref = collection.seo) === null || ref === void 0 ? void 0 : ref.featured_publishers) !== undefined && collection.seo.featured_publishers.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDirection: "column",
                gridRowGap: 16,
                width: "100%",
                alignItems: "center",
                mt: isMobileView ? 40 : 88,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.bold : esm.typography.primaryHeadingFonts.large.bold), {
                        color: esm.color[colorMode].text,
                        textAlign: "center"
                    }), isMobileView ? {
                        px: 16
                    } : {}), {
                        children: "Influential people you will learn from"
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        width: "100%",
                        flexDirection: "row",
                        gridColumnGap: 32,
                        justifyContent: isMobileView ? "start" : "center",
                        mt: 16
                    }, isMobileView ? {
                        overflow: "scroll",
                        px: 16,
                        pb: 8
                    } : {}), {
                        children: collection.seo.featured_publishers.slice(0, 5).map(function(publisher, index) {
                            var _image;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                w: isMobileView ? AUTHOR_SIZE_MOBILE.WIDTH_CONTAINER : AUTHOR_SIZE.WIDTH,
                                flexDirection: "column",
                                gridRowGap: 16,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                        wrapperStyle: {
                                            width: isMobileView ? AUTHOR_SIZE_MOBILE.WIDTH : AUTHOR_SIZE.WIDTH,
                                            height: isMobileView ? AUTHOR_SIZE_MOBILE.HEIGHT : AUTHOR_SIZE.HEIGHT,
                                            borderRadius: 200,
                                            cursor: "default"
                                        },
                                        imageUrl: (_image = publisher.image) !== null && _image !== void 0 ? _image : DEFAULT_AUTHOR_IMAGE,
                                        defaultImage: DEFAULT_AUTHOR_IMAGE,
                                        alt: "".concat(publisher.name),
                                        priority: true,
                                        objectFit: "cover",
                                        objectPosition: "top"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "center"
                                    }, isMobileView ? esm.typography.primaryTextFonts.large.regular : esm.typography.primaryHeadingFonts.small.regular), {
                                        color: esm.color[colorMode].text,
                                        noOfLines: 3,
                                        w: isMobileView ? AUTHOR_SIZE_MOBILE.WIDTH_CONTAINER : AUTHOR_SIZE.WIDTH,
                                        children: "".concat(publisher.name)
                                    }))
                                ]
                            }, index);
                        })
                    }))
                ]
            });
        } else {
            return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        width: "100%",
        children: [
            renderSourcesView(),
            renderPeopleView()
        ]
    });
};
/* harmony default export */ var components_CollectionOverviewSection = (CollectionOverviewSection);

// EXTERNAL MODULE: ./src/utils/StringUtils.tsx
var StringUtils = __webpack_require__(94030);
// EXTERNAL MODULE: ./src/theme/icons/index.ts + 37 modules
var icons = __webpack_require__(49834);
// EXTERNAL MODULE: ./src/utils/date-utils.ts
var date_utils = __webpack_require__(61439);
;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionPageHeader.tsx










var IMAGE_SIZE = {
    WIDTH: 220,
    HEIGHT: 320,
    BORDER_RADIUS: 16
};
var CollectionPageHeader = function(param) {
    var collection = param.collection;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var total_article_sources = collection.total_article_sources, total_book_sources = collection.total_book_sources, total_podcast_sources = collection.total_podcast_sources, total_video_sources = collection.total_video_sources, time_to_read = collection.time_to_read;
    var minutesToRead = react.useMemo(function() {
        if (time_to_read !== undefined) {
            return (0,date_utils/* formatSecondsToNearestMinute */.b6)(time_to_read);
        }
        return undefined;
    }, [
        time_to_read
    ]);
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
        wrapperStyle: {
            width: IMAGE_SIZE.WIDTH,
            height: IMAGE_SIZE.HEIGHT,
            borderRadius: IMAGE_SIZE.BORDER_RADIUS,
            cursor: "default"
        },
        imageUrl: collection.image_compressed || collection.image,
        alt: "".concat(collection.name, " Collection"),
        blurhash: collection.image_blurhash,
        priority: true
    });
    var renderChipSourceType = function(param) {
        var sourceType = param.sourceType, total = param.total;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "row",
            alignItems: "center",
            gridColumnGap: 2,
            // bgColor={color[colorMode].surface}
            px: 8,
            py: 4,
            borderRadius: 16,
            children: [
                sourceType === enums/* SourceType.BOOK */.PO.BOOK ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.BookIconSvg, {
                    color: esm.color[colorMode].text
                }) : null,
                sourceType === enums/* SourceType.BOOK */.PO.BOOK ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].text,
                    children: "".concat(total, " ").concat((0,StringUtils/* getSingularOrPlural */.Lo)(total, "book", "books"))
                })) : null,
                sourceType === enums/* SourceType.PODCAST */.PO.PODCAST ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.SpotifySvg, {
                    color: "#1DB954"
                }) : null,
                sourceType === enums/* SourceType.PODCAST */.PO.PODCAST ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].text,
                    children: "".concat(total, " ").concat((0,StringUtils/* getSingularOrPlural */.Lo)(total, "podcast", "podcasts"))
                })) : null,
                sourceType === enums/* SourceType.VIDEO */.PO.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.YouTubeSvg, {
                    color: "red"
                }) : null,
                sourceType === enums/* SourceType.VIDEO */.PO.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].text,
                    children: "".concat(total, " ").concat((0,StringUtils/* getSingularOrPlural */.Lo)(total, "video", "videos"))
                })) : null,
                sourceType === enums/* SourceType.ARTICLE */.PO.ARTICLE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.GlobeSvg, {
                    color: esm.color[colorMode].text
                }) : null,
                sourceType === enums/* SourceType.ARTICLE */.PO.ARTICLE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].text,
                    children: "".concat(total, " ").concat((0,StringUtils/* getSingularOrPlural */.Lo)(total, "article", "articles"))
                })) : null
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: isMobileView ? "column" : "row",
        gridColumnGap: 32,
        gridRowGap: 32,
        alignItems: isMobileView ? "center" : "start",
        children: [
            imageComponent,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDirection: "column",
                flex: 1,
                children: [
                    !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.bold), {
                        color: esm.color[colorMode].textSecondary,
                        textTransform: "uppercase",
                        letterSpacing: 2,
                        textAlign: {
                            sm: "center",
                            md: "unset"
                        },
                        children: "A DEEP DIVE INTO "
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.xl.bold, isMobileView ? esm.typography.primaryHeadingFonts.large.bold : esm.typography.primaryHeadingFonts.xl.bold), {
                        color: esm.color[colorMode].text,
                        textAlign: isMobileView ? "center" : "start",
                        size: "h1",
                        children: collection.name
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                        color: esm.color[colorMode].text,
                        textAlign: isMobileView ? "center" : "start",
                        mt: isMobileView ? 16 : 0,
                        children: collection.description
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        mt: 32,
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                                color: esm.color[colorMode].text,
                                children: "".concat(collection.total_blocks, " key ideas from")
                            })),
                            total_book_sources !== undefined && total_book_sources > 0 ? renderChipSourceType({
                                sourceType: enums/* SourceType.BOOK */.PO.BOOK,
                                total: total_book_sources
                            }) : null,
                            total_podcast_sources !== undefined && total_podcast_sources > 0 ? renderChipSourceType({
                                sourceType: enums/* SourceType.PODCAST */.PO.PODCAST,
                                total: total_podcast_sources
                            }) : null,
                            total_video_sources !== undefined && total_video_sources > 0 ? renderChipSourceType({
                                sourceType: enums/* SourceType.VIDEO */.PO.VIDEO,
                                total: total_video_sources
                            }) : null,
                            total_article_sources !== undefined && total_article_sources > 0 ? renderChipSourceType({
                                sourceType: enums/* SourceType.ARTICLE */.PO.ARTICLE,
                                total: total_article_sources
                            }) : null
                        ]
                    }),
                    minutesToRead !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        mt: 8,
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                                color: esm.color[colorMode].text,
                                children: "It takes just"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                boxSize: "24px",
                                alignItems: "center",
                                justifyContent: "center",
                                ml: 8,
                                mr: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClockIconSvg */.$A, {
                                    width: 24,
                                    height: 24,
                                    color: esm.color[colorMode].text
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                                color: esm.color[colorMode].text,
                                children: "".concat(minutesToRead, " to read")
                            }))
                        ]
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CollectionPageHeader = (CollectionPageHeader);

;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionSignUpSection.tsx







var CollectionSignUpSection_TITLE = "Start collection & level up your skills.";
var CollectionSignUpSection = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    // const isMobileView = useIsMobileView();
    var colorMode = (0,esm.useColorMode)().colorMode;
    // TODO No Trial Changes
    // const { stripePrices, requestStatus } = useStripePrices({
    //   requestNsi: true,
    // });
    // const freeTrialSubscription = stripePrices?.subscriptions['1 YEAR'];
    // const normalizedPrice = `$${freeTrialSubscription?.pricePerMonth}/month`;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: "100%",
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.semiBold), {
                color: esm.color[colorMode].text,
                textAlign: "center",
                children: CollectionSignUpSection_TITLE
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                color: esm.color[colorMode].textSecondary,
                textAlign: "center",
                mt: 8,
                children: "Embark on your personal growth journey with Deepstash Pro."
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartTrialButton/* default */.Z, {
                landingLocation: "collection-first-section",
                mt: 16,
                px: 80
            })
        ]
    });
};
/* harmony default export */ var components_CollectionSignUpSection = (CollectionSignUpSection);

;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionSimilarCollectionsSection.tsx








 // Use it instead of own useRouter for fixing scroll problems
var COLLECTION_IMAGE_SIZE = {
    WIDTH: 200,
    HEIGHT: 300,
    BORDER_RADIUS: 16
};
var CollectionSimilarCollectionsSection_TITLE = "Similar Collections";
var CollectionSimilarCollectionsSection = function(param) {
    var similarCollections = param.similarCollections;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var router = (0,next_router.useRouter)();
    var renderCollectionsCarousel = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
            flexDirection: "column",
            gridRowGap: 16,
            mt: 32,
            width: "100%",
            overflow: "hidden",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: "100%",
                flexDirection: "row",
                gridColumnGap: 16
            }, isMobileView ? {
                overflow: "scroll",
                px: 16,
                pb: 16
            } : {}), {
                justifyContent: isMobileView ? "flex-start" : "center",
                children: similarCollections.map(function(collection, index) {
                    var collectionSlug = (0,global/* slugify */.lV)(collection.name);
                    var collectionPageRoute = "/collection/".concat(collection.id, "/").concat(collectionSlug);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        w: 200,
                        flexDirection: "column",
                        gridRowGap: 16,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                wrapperStyle: {
                                    width: COLLECTION_IMAGE_SIZE.WIDTH,
                                    height: COLLECTION_IMAGE_SIZE.HEIGHT,
                                    borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
                                    cursor: "pointer"
                                },
                                imageUrl: collection.image,
                                blurhash: collection.image_blurhash,
                                alt: "".concat(collection.name),
                                priority: false,
                                onClick: function() {
                                    router.push(collectionPageRoute);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: collectionPageRoute,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                    _focus: undefined,
                                    _hover: undefined,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        textAlign: "center"
                                    }, esm.typography.primaryHeadingFonts.small.regular), {
                                        color: esm.color[colorMode].text,
                                        children: "".concat(collection.name)
                                    }))
                                })
                            }, "book-".concat(index))
                        ]
                    }, index);
                })
            }))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        mt: isMobileView ? 32 : 128,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.bold : esm.typography.primaryHeadingFonts.large.bold), {
                color: esm.color[colorMode].text,
                textAlign: "center",
                children: CollectionSimilarCollectionsSection_TITLE
            })),
            renderCollectionsCarousel()
        ]
    });
};
/* harmony default export */ var components_CollectionSimilarCollectionsSection = (CollectionSimilarCollectionsSection);

;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionSkillsSection.tsx






var CollectionSkillsSection_TITLE = "What you'll learn";
var FALLBACK_SKILLS = [
    "How to prioritize tasks effectively",
    "How to minimize distractions",
    "How to optimize your work environment",
    "How to use technology to your advantage",
    "How to delegate tasks efficiently", 
];
var CollectionSkillsSection = function(param) {
    var skills = param.skills;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var finalSkills = react.useMemo(function() {
        return skills !== undefined ? skills : FALLBACK_SKILLS;
    }, [
        skills
    ]);
    var renderSkill = function(param) {
        var skill = param.skill, index = param.index;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "row",
            alignItems: "flex-start",
            gridColumnGap: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CheckFillSvg, {
                    color: "green",
                    boxSize: isMobileView ? "28px" : "34px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.regular : esm.typography.primaryHeadingFonts.medium.regular), {
                    color: esm.color[colorMode].textSecondary,
                    flex: 1,
                    children: skill
                }))
            ]
        }, "skill-".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: isMobileView ? "column" : "row",
        width: "100%",
        gridColumnGap: 64,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                flexDirection: "column"
            }, isMobileView ? {
                alignItems: "center"
            } : {
                flex: 1.2
            }), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.large.bold : esm.typography.primaryHeadingFonts.xl.bold), {
                        color: esm.color[colorMode].text,
                        textAlign: isMobileView ? "center" : "start",
                        children: CollectionSkillsSection_TITLE
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        flexDirection: "column",
                        gridRowGap: 16,
                        mt: 24
                    }, isMobileView ? {
                        width: "100%"
                    } : {}), {
                        children: finalSkills.map(function(skill, index) {
                            return renderSkill({
                                skill: skill,
                                index: index
                            });
                        })
                    }))
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? {
                mt: 32
            } : {
                flex: 1
            }), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    wrapperStyle: {
                        width: isMobileView ? 300 : 500,
                        height: isMobileView ? 250 : 408,
                        pointerEvents: "none"
                    },
                    objectFit: "contain",
                    imageUrl: "https://static.deepstash.com/phone-landing-image.png"
                })
            }))
        ]
    });
};
/* harmony default export */ var components_CollectionSkillsSection = (CollectionSkillsSection);

;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionSubscriptionSection.tsx







var CollectionSubscriptionSection_TITLE = "What's in every Deepstash membership?";
var CollectionSubscriptionSection = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDirection: isMobileView ? "column" : "row",
        width: "100%",
        gridColumnGap: 32,
        mt: isMobileView ? 32 : 128
    }, isMobileView ? {
        alignItems: "center",
        gridRowGap: 32,
        px: 16
    } : {}), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.large.bold : esm.typography.primaryHeadingFonts.xl.bold), {
                    color: esm.color[colorMode].text
                }), isMobileView ? {
                    textAlign: "center"
                } : {}), {
                    children: CollectionSubscriptionSection_TITLE
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flex: 0.9,
                flexDirection: "column",
                justifyContent: "center",
                gridRowGap: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumnGap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.BookIconSvg, {
                                color: esm.color[colorMode].text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.regular), {
                                color: esm.color[colorMode].text,
                                children: "Key ideas from 1,000+ books"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumnGap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.LibrarySvg, {
                                color: esm.color[colorMode].text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.regular), {
                                color: esm.color[colorMode].text,
                                children: "Access to 200,000+ ideas"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumnGap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PhoneSvg, {
                                color: esm.color[colorMode].text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.regular), {
                                color: esm.color[colorMode].text,
                                children: "Personalized recommendations"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumnGap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.HeadphonesSvg, {
                                color: esm.color[colorMode].text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.regular), {
                                color: esm.color[colorMode].text,
                                children: "Listen instead of reading"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        gridColumnGap: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.StashedSvg, {
                                color: esm.color[colorMode].text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.regular), {
                                color: esm.color[colorMode].text,
                                children: "Build your knowledge library"
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        flexDirection: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartTrialButton/* default */.Z, {
                            landingLocation: "collection-membership",
                            mt: 16,
                            width: isMobileView ? "100%" : "70%"
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_CollectionSubscriptionSection = (CollectionSubscriptionSection);

// EXTERNAL MODULE: ./src/page-components/collection/components/CollectionTabs.module.scss
var CollectionTabs_module = __webpack_require__(92279);
var CollectionTabs_module_default = /*#__PURE__*/__webpack_require__.n(CollectionTabs_module);
;// CONCATENATED MODULE: ./src/page-components/collection/components/CollectionTabs.tsx







var COLLECTIONS_TABS_HEIGHT = 60;
var CollectionTabs = function(param) {
    var tabs = param.tabs, currentTabIndex = param.currentTabIndex, onPressToChangeTab = param.onPressToChangeTab;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var containerRef = react.useRef(null);
    var tabsRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(undefined), 2), topDiff = ref[0], setTopDiff = ref[1];
    react.useLayoutEffect(function() {
        var ref;
        var boundingClientRect = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect();
        if (boundingClientRect) {
            setTopDiff(boundingClientRect.top);
        }
    }, []);
    react.useEffect(function() {
        var scrollListener = function() {
            if (topDiff === undefined) {
                return;
            }
            var scrollY = window.scrollY;
            if (scrollY >= topDiff) {
                var // Make it sticky
                ref;
                (ref = tabsRef.current) === null || ref === void 0 ? void 0 : ref.classList.add((CollectionTabs_module_default()).sticky);
            } else {
                var // Remove sticky
                ref1;
                (ref1 = tabsRef.current) === null || ref1 === void 0 ? void 0 : ref1.classList.remove((CollectionTabs_module_default()).sticky);
            }
        };
        addEventListener("scroll", scrollListener);
        return function() {
            removeEventListener("scroll", scrollListener);
        };
    }, [
        topDiff
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: "100%",
        flexDirection: "column",
        alignItems: "center",
        ref: containerRef,
        height: COLLECTIONS_TABS_HEIGHT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDirection: "row",
                bgColor: esm.color[colorMode].background,
                width: "100%",
                justifyContent: "center",
                height: COLLECTIONS_TABS_HEIGHT,
                ref: tabsRef,
                alignItems: "flex-end",
                children: tabs.map(function(tab, index) {
                    var isTabSelected = currentTabIndex === index;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        width: 160,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        height: "100%",
                        cursor: "pointer",
                        onClick: function() {
                            onPressToChangeTab({
                                newIndex: index
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? esm.typography.primaryHeadingFonts.small.regular : esm.typography.primaryHeadingFonts.medium.regular), {
                                color: isTabSelected ? esm.color[colorMode].text : esm.color[colorMode].textDisabled,
                                children: tab
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                h: 2,
                                w: "100%",
                                mt: 8,
                                bgColor: isTabSelected ? esm.color[colorMode].text : esm.color[colorMode].underground
                            })
                        ]
                    }, "tab-".concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                width: "100%",
                height: COLLECTIONS_TABS_HEIGHT,
                position: "absolute",
                top: 0,
                left: 0,
                pointerEvents: "none"
            })
        ]
    });
};
/* harmony default export */ var components_CollectionTabs = (CollectionTabs);

;// CONCATENATED MODULE: ./src/page-components/collection/CollectionNSIPage.tsx






















var TABS = [
    "Skills",
    "Overview",
    "Key Ideas",
    "FAQ"
];
var ID_SKILLS = "id_skills";
var ID_OVERVIEW = "id_overview";
var ID_KEY_IDEAS = "id_key_ideas";
var ID_FAQ = "id_faq";
// Used for scrollTo functions
var PT_SECTION = COLLECTIONS_TABS_HEIGHT + 16;
var CollectionNSIPage = function(param) {
    var collection = param.collection;
    var ref, ref1, ref2;
    var isMobileView = (0,esm.useIsMobileView)();
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), currentTabIndex = ref3[0], setCurrentTabIndex = ref3[1];
    var skillsSectionRef = react.useRef(null);
    var overviewSectionRef = react.useRef(null);
    var keyIdeasSectionRef = react.useRef(null);
    var faqSectionRef = react.useRef(null);
    var onPressToChangeTab = function(param) {
        var newIndex = param.newIndex;
        if (newIndex >= TABS.length || newIndex < 0) {
            return;
        }
        setCurrentTabIndex(function(prevIndex) {
            if (newIndex === 0) {
                var ref;
                (ref = skillsSectionRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    block: "start"
                });
            } else if (newIndex === 1) {
                var ref1;
                (ref1 = overviewSectionRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
                    block: "start"
                });
            } else if (newIndex === 2) {
                var ref2;
                (ref2 = keyIdeasSectionRef.current) === null || ref2 === void 0 ? void 0 : ref2.scrollIntoView({
                    block: "start"
                });
            } else if (newIndex === 3) {
                var ref3;
                (ref3 = faqSectionRef.current) === null || ref3 === void 0 ? void 0 : ref3.scrollIntoView({
                    block: "start"
                });
            }
            if (prevIndex === newIndex) {
                return prevIndex;
            }
            return newIndex;
        });
    };
    react.useEffect(function() {
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var id = entry.target.id;
                    switch(id){
                        case ID_SKILLS:
                            setCurrentTabIndex(0);
                            break;
                        case ID_OVERVIEW:
                            setCurrentTabIndex(1);
                            break;
                        case ID_KEY_IDEAS:
                            setCurrentTabIndex(2);
                            break;
                        case ID_FAQ:
                            setCurrentTabIndex(3);
                            break;
                        default:
                            break;
                    }
                }
            });
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.2
        });
        // Add observers for all sections
        if (skillsSectionRef.current) {
            observer.observe(skillsSectionRef.current);
        }
        if (overviewSectionRef.current) {
            observer.observe(overviewSectionRef.current);
        }
        if (keyIdeasSectionRef.current) {
            observer.observe(keyIdeasSectionRef.current);
        }
        if (faqSectionRef.current) {
            observer.observe(faqSectionRef.current);
        }
        return function() {
            // Remove observers for all sections
            if (skillsSectionRef.current) {
                observer.unobserve(skillsSectionRef.current);
            }
            if (overviewSectionRef.current) {
                observer.unobserve(overviewSectionRef.current);
            }
            if (keyIdeasSectionRef.current) {
                observer.unobserve(keyIdeasSectionRef.current);
            }
            if (faqSectionRef.current) {
                observer.unobserve(faqSectionRef.current);
            }
        };
    }, []);
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: "100%",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                containerProps: !!((ref = collection.hashtags) === null || ref === void 0 ? void 0 : ref.length) ? {
                    flexDirection: "column",
                    gridGap: 0
                } : {},
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    !!((ref1 = collection.hashtags) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbList/* default */.Z, {
                        items: [
                            {
                                title: "Home",
                                link: "/"
                            },
                            {
                                title: (ref4 = (ref2 = metatopics_constants/* UNSORTED_TOPICS */.Ay[collection.hashtags[0]]) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref4 !== void 0 ? ref4 : collection.hashtags[0],
                                link: "/topic/" + collection.hashtags[0]
                            },
                            {
                                title: collection.name,
                                link: "/collection/".concat(collection.id, "/").concat((0,global/* slugify */.lV)(collection.name))
                            }, 
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                mt: 64,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionPageHeader, {
                    collection: collection
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                mt: 64,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionSignUpSection, {})
            }),
            !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                mt: 64,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionTabs, {
                    tabs: TABS,
                    currentTabIndex: currentTabIndex,
                    onPressToChangeTab: onPressToChangeTab
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                mt: isMobileView ? 60 : 64,
                pt: isMobileView ? 0 : PT_SECTION,
                ref: skillsSectionRef,
                id: ID_SKILLS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionSkillsSection, {
                    skills: collection.skills
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mt: isMobileView ? 72 : 80,
                pt: isMobileView ? 0 : PT_SECTION,
                ref: overviewSectionRef,
                id: ID_OVERVIEW
            }, isMobileView ? {
                containerProps: {
                    px: 0
                }
            } : {}), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionOverviewSection, {
                    collection: collection
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mt: isMobileView ? 72 : 80,
                pt: isMobileView ? 0 : PT_SECTION,
                ref: keyIdeasSectionRef,
                id: ID_KEY_IDEAS
            }, isMobileView ? {
                containerProps: {
                    px: 0,
                    flexDirection: "column"
                }
            } : {
                containerProps: {
                    flexDirection: "column",
                    alignItems: "center"
                }
            }), {
                children: [
                    collection.articles !== undefined && collection.articles !== null && collection.articles.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionKeyIdeasSection, {
                        articles: collection.articles,
                        totalIdeas: collection.total_blocks
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionSubscriptionSection, {}),
                    collection.similar_collections !== undefined && collection.similar_collections !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionSimilarCollectionsSection, {
                        similarCollections: collection.similar_collections
                    }) : null
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                mb: isMobileView ? 44 : 128,
                mt: isMobileView ? 72 : 80,
                pt: isMobileView ? 0 : PT_SECTION,
                ref: faqSectionRef,
                id: ID_FAQ,
                containerProps: {
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionFAQSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingProSection/* default */.Z, {
                        showProComparison: false,
                        px: 0,
                        width: "100%",
                        landingLocation: "collection-last-section"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var collection_CollectionNSIPage = (CollectionNSIPage);

// EXTERNAL MODULE: ./src/components/metadata/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(37066);
;// CONCATENATED MODULE: ./pages/collection/[id]/[slug].tsx











var CollectionDynamicPage = function(param) {
    var collection = param.collection, isInitialLoggedIn = param.isInitialLoggedIn;
    var normalizedCollection = (0,normalizers_collection/* normalizeCollection */.Vf)(collection);
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    (0,react.useEffect)(function() {
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.viewCollection */.z.consumption.viewCollection,
            properties: {
                collectionId: collection.id,
                collectionStatus: (0,collection_utils/* getCollectionStatus */.t2)({
                    collection: normalizedCollection
                })
            },
            platforms: [
                "amplitude"
            ]
        });
    }, []);
    if (!isLoggedIn) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                    pageMetadata: (0,metadata_utils/* getCollectionPageMetadata */.NJ)({
                        collection: normalizedCollection
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(collection_CollectionNSIPage, {
                    collection: collection
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(old_CollectionPage, {
        collection: normalizedCollection,
        isInitialLoggedIn: isInitialLoggedIn
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (CollectionDynamicPage);


/***/ }),

/***/ 35905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MENU_OPTIONS": function() { return /* binding */ MENU_OPTIONS; },
  "OWNER_OPTIONS": function() { return /* binding */ OWNER_OPTIONS; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/components/source/source-preview/SourcePreview.tsx + 2 modules
var SourcePreview = __webpack_require__(34549);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/chips/Chip.tsx
var Chip = __webpack_require__(34001);
// EXTERNAL MODULE: ./src/utils/StringUtils.tsx
var StringUtils = __webpack_require__(94030);
;// CONCATENATED MODULE: ./src/page-components/search/components/HashtagSearchedResultMobile.tsx







var HashtagSearchedResultDesktop = function(param) {
    var searchedHashtag = param.searchedHashtag;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var _sources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDir: "column",
        align: "flex-start",
        mb: global/* BLOCK_WIDTH_REM */.sC,
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                alignItems: "center",
                gridGap: esm.spacing.M.rem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        content: "#" + searchedHashtag.name,
                        href: "topic/".concat(searchedHashtag.name),
                        m: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, {
                        fontSize: "0.8em",
                        color: esm.color[colorMode].textDisabled,
                        children: [
                            (0,global/* numberFormatter */.V2)(searchedHashtag.totalIdeas),
                            " ",
                            (0,StringUtils/* getSingularOrPlural */.Lo)(searchedHashtag.totalIdeas, "idea", "ideas")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                mt: global/* GAP_SIZE_REM */.L3,
                gridGap: global/* GAP_SIZE_REM */.L3,
                width: "100%",
                overflow: {
                    base: "scroll",
                    md: "hidden"
                },
                children: ((_sources = searchedHashtag.sources) !== null && _sources !== void 0 ? _sources : []).slice(0, 4).map(function(source) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                        size: "small",
                        source: source
                    }, source.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HashtagSearchedResultMobile = (HashtagSearchedResultDesktop);

// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/components/social/ProfilePicture.tsx
var ProfilePicture = __webpack_require__(7877);
// EXTERNAL MODULE: ./src/components/buttons/FollowUserButton.tsx + 1 modules
var FollowUserButton = __webpack_require__(97360);
;// CONCATENATED MODULE: ./src/page-components/search/components/UserInfo.tsx








var UserInfo = function(param) {
    var user = param.user, index = param.index;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var profile = (0,useProfile/* default */.Z)().profile;
    var _bio;
    var bioFragments = (0,react.useMemo)(function() {
        return (0,StringUtils/* fragmentTextWithEmojis */.CO)((_bio = user.bio) !== null && _bio !== void 0 ? _bio : "");
    }, [
        user
    ]);
    if (!user) return null;
    var _photo;
    var displayUser = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        _focus: undefined,
        _active: undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePicture/* default */.Z, {
                m: esm.spacing.toRem(2),
                photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                size: "l",
                imageBlurhash: user.photo_blurhash
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                ml: "8px",
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        fontSize: "16px",
                        lineHeight: "19px",
                        fontWeight: "bold",
                        color: esm.color[colorMode].primary,
                        _hover: {
                            textDecoration: "underline"
                        },
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: "@" + user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        color: esm.color[colorMode].textSecondary,
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: !!user.firstName || !!user.lastName ? "".concat(user.firstName, " ").concat(user.lastName) : user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        textAlign: "center",
                        w: "100%",
                        children: bioFragments.map(function(fragment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                size: "s",
                                color: esm.color[colorMode].textDisabled,
                                textOverflow: "ellipsis",
                                noOfLines: 1,
                                children: fragment
                            }, fragment);
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        bgColor: esm.color[colorMode].top,
        p: esm.spacing.toRem(16),
        borderRadius: esm.spacing.toRem(20),
        mb: esm.spacing.toRem(12),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            justifyContent: "space-between",
            alignItems: "start",
            _focus: undefined,
            _active: undefined,
            wordBreak: "break-all",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/u/".concat(user.username),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        w: "100%",
                        _focus: undefined,
                        _active: undefined,
                        _hover: undefined,
                        children: displayUser
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowUserButton/* default */.Z, {
                    display: (profile === null || profile === void 0 ? void 0 : profile.id) === user.id ? "none" : "inline-flex",
                    userId: user.id,
                    size: "sm",
                    px: esm.spacing.toRem(12),
                    py: esm.spacing.toRem(6)
                })
            ]
        })
    }, index);
};
/* harmony default export */ var components_UserInfo = (UserInfo);

;// CONCATENATED MODULE: ./src/page-components/search/SearchPage.tsx









var SearchPageMobile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9283).then(__webpack_require__.bind(__webpack_require__, 19283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19283)
            ];
        }
    }
});
var SearchPageDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9891), __webpack_require__.e(9834), __webpack_require__.e(2853), __webpack_require__.e(1425), __webpack_require__.e(7436)]).then(__webpack_require__.bind(__webpack_require__, 16171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16171)
            ];
        }
    }
});
SearchPageDesktop.displayName = "SearchPageDesktop";
SearchPageMobile.displayName = "SearchPageMobile";
var SearchPage = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    var isMobileView = (0,esm.useIsMobileView)();
    /**
   * Render the search results
   * @param feed The results to be rendered
   * @param isFetching Whether or not we are currently fetching more results
   * @param searchType What we are searching for
   * @param errorMessage A component to be shown if no results were found
   */ var renderFeed = (0,react.useCallback)(function(feed, isFetching, searchType, errorMessage) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm.Box, {
            children: !isFetching && (!feed || feed.length === 0) ? errorMessage : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                children: [
                    searchType === "article" && feed.map(function(source) {
                        if ((0,global/* isSourceEmpty */.dq)(source)) return null;
                        if (searchType === "article") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                                    source: source,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, "articleCard$".concat(source.id));
                        }
                        return null;
                    }),
                    searchType === "block" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        flexDir: "column",
                        width: "100%",
                        alignItems: "center",
                        children: feed === null || feed === void 0 ? void 0 : feed.map(function(idea) {
                            var source = idea.source;
                            if (!source || (0,global/* isSourceEmpty */.dq)(source)) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourcePreview/* default */.Z, {
                                    source: source,
                                    ideaId: idea.id,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, source.id);
                        })
                    }),
                    searchType === "user" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(user, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                user: user,
                                index: index
                            }, user.id);
                        })
                    }),
                    searchType === "hashtag" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(searchedHashtag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HashtagSearchedResultMobile, {
                                searchedHashtag: searchedHashtag
                            }, "SearchHashtagSection-".concat(searchedHashtag.name, "-").concat(index));
                        })
                    })
                ]
            })
        });
    }, []);
    return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageMobile, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageDesktop, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    });
};
/* harmony default export */ var search_SearchPage = (SearchPage);

;// CONCATENATED MODULE: ./pages/search.tsx



var MENU_OPTIONS = [
    {
        title: "Ideas",
        key: "block"
    },
    {
        title: "People",
        key: "user"
    },
    {
        title: "Topics",
        key: "hashtag"
    },
    {
        title: "Sources",
        key: "article"
    }, 
];
var OWNER_OPTIONS = [
    {
        title: "All",
        key: "all"
    },
    {
        title: "Own",
        key: "own"
    }, 
];
var Search = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SearchPage, {
        initialApiData: initialApiData !== null && initialApiData !== void 0 ? initialApiData : undefined,
        initialSearchType: initialSearchType !== null && initialSearchType !== void 0 ? initialSearchType : undefined
    });
};
// export const getServerSideProps: GetServerSideProps<OwnProps> = async ctx => {
//   const { q, owner, tab } = ctx.query;
//   const { token } = cookie.parse(ctx.req.headers.cookie ?? '');
//   if (!q) {
//     return {
//       props: {
//         initialApiData: null,
//         initialSearchType: null,
//       },
//     };
//   }
//   //Get rid of the # in the query
//   let parsedSearchText = q as string;
//   if (parsedSearchText.includes('#')) {
//     parsedSearchText = replaceAll(parsedSearchText, '#', '');
//   }
//   //Get the search type based on the query param
//   const searchType =
//     MENU_OPTIONS.find(
//       option => option.title.toLowerCase() === (tab as SearchType),
//     )?.key ?? 'block';
//   const res = await search(
//     parsedSearchText,
//     searchType,
//     owner as 'all' | 'own',
//     token,
//   );
//   return {
//     props: {
//       initialApiData: res ?? null,
//       initialSearchType: searchType,
//     },
//   };
// };
/* harmony default export */ var search = (Search);


/***/ }),

/***/ 22319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);







var FullWidthScrollableWrapper = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(_param, ref) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE_REM */ .L3,
        justifyContent: "left",
        width: "100%",
        px: {
            base: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE_REM */ .L3,
            md: "calc(50vw - 368px)",
            lg: "calc(50vw - 560px)"
        },
        overflowX: "scroll",
        alignItems: "flex-start",
        ref: ref,
        pb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.px
    }, props), {
        children: children
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthScrollableWrapper);


/***/ }),

/***/ 92279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sticky":"CollectionTabs_sticky__lhpuP","not_sticky":"CollectionTabs_not_sticky__3vNPa"};

/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldGet; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_extract_field_descriptor.mjs
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_apply_descriptor_get.mjs
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_get.mjs



function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}


/***/ }),

/***/ 70222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldInit; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_check_private_redeclaration.mjs
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_init.mjs


function _classPrivateFieldInit(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,9000,9891,9834,5611,2853,3244,7531,9774,2888,179], function() { return __webpack_exec__(59295); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);